<script setup lang="ts">
const { t } = useEkI18n();
const settingsStore = useSettingsStore();

async function showWholesalerImages(value: boolean) {
  await settingsStore.set('showWholesalerCatalogItemImages', value);
}
</script>

<template>
  <SettingsToggle
    :checked="settingsStore.settings.showWholesalerCatalogItemImages"
    :label="t('settings.materials.showWholesalerItemImages')"
    :description="t('settings.materials.showWholesalerItemImagesDescription')"
    @change="showWholesalerImages"
  />
</template>
